import React from "react";
import { Outlet } from "react-router-dom";
import { Version } from "../components/Version/Version";

export const LayoutAuth = () => {
    return (
        <section className="w-full h-screen flex flex-col ">
            <header className="bg-[#282828] h-0 w-full "></header>
            <div className="w-full grow flex ">
                <Outlet />
            </div>
            <div className="fixed bottom-0 left-0 bg-black px-4 py-2 z-10 opacity-70">
                <Version />
            </div>
        </section>
    );
};
